import * as React from 'react';
import { Button } from 'primereact/button';
import { Alert } from 'reactstrap';
import { ProgressBar } from 'primereact/progressbar';
import { useAuth0 } from '../../../auth/react-auth0-wrapper'
import Can from "../../../auth/Can";
import roles from "../../../auth/roles";
import moment from 'moment';

export default function QuadroTestAnswer({
    trigger,
    verify,
    triggerNextStep,
    deviceId,
    step
}) {
    const { gisApi } = useAuth0();
    const [loading, setLoading] = React.useState(false);
    const completed = step.value && step.value.completed;
    const error = step.value && step.value.error;

    const checkValidState = position => {
        const on = position.attributes.di1 ? true : false;
        return verify === 'on' ? on : !on;
    };

    async function executeTest() {
        setLoading(true);
        const position = await gisApi.getLastPosition(deviceId);
        setLoading(false);
        if (!position) {
            return {
                ok: false,
                error: `Impossibile rilevare dati dal dispositivo. Si prega di riprovare.`
            };
        } else if (!checkValidState(position)) {
            return {
                ok: false,
                error: `Quadro rilevato come ${
                    verify === 'on' ? 'spento' : 'acceso'
                    }. Attendere qualche istante e riprovare. Se il problema persiste verificare l’installazione (positivo sotto chiave +15) per poi ripetere il test.`
            };
        } else {
            return { ok: true, position };
        }
    }

    return (
        <div>
            <Alert
                color={error ? 'danger' : completed ? 'success' : 'info'}
                title={
                    `Test verifica quadro rilevato in stato ${
                    verify === 'on' ? 'acceso' : 'spento'
                    } ?`
                }
            >
                <div>
                    {loading && (
                        <div>
                            <div>{'Rilevamento dati in corso...'}</div>
                            <ProgressBar className="mb-2" mode="indeterminate" style={{ height: '8px' }} />
                        </div>
                    )}
                    {error && <div className="text-red mb-4">{error}</div>}
                    {completed && (
                        <div className="text-green mb-4">
                            {
                                `Quadro correttamente rilevato come ${
                                verify === 'on' ? 'acceso' : 'spento'
                                }`
                            }
                        </div>
                    )}
                    {!error && !completed && (
                        <div>
                            <Button
                                disabled={loading}
                                label={
                                    `Confermo che il quadro auto è ${
                                    verify === 'on' ? 'acceso' : 'spento'
                                    }`
                                }
                                icon="pi pi-check"
                                onClick={async () => {
                                    const testResult = await executeTest();
                                    if (testResult.ok) {
                                        triggerNextStep({
                                            trigger: trigger,
                                            value: { completed: true, position: testResult.position, timestamp: moment().toJSON() }
                                        });
                                    } else {
                                        triggerNextStep({
                                            trigger: step.id,
                                            value: {
                                                error: testResult.error, timestamp: moment().toJSON()
                                            }
                                        });
                                    }
                                }}
                                className="p-button-success p-button-rounded"
                            />

                            <Can
                                roles={[roles.ADMIN]}
                                yes={() =>
                                    <Button
                                        className="p-button-danger p-button-rounded ml-2"
                                        label={'FORZA TEST'}
                                        icon="fas fa-fast-forward"
                                        onClick={async () => {
                                            if (confirm('Confermi di voler forzare il test del quadro?')) {
                                                triggerNextStep({
                                                    trigger: 'test-quadro-end',
                                                    value: { skipped: true, completed: true, timestamp: moment().toJSON() }
                                                });
                                            }
                                        }}
                                    />
                                }
                                no={() => null}
                            />
                        </div>
                    )}
                </div>
            </Alert>
        </div>
    );
}
